module.exports = __webpack_public_path__ + "img/cheese-calzone.19dcc9dd.jpg";